import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function NotFound() {
    return (
        <div className="max-w-3xl mx-auto px-6 py-24 text-center">
            <Helmet>
                <title>Page not found | MM AutoTech</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <p className="text-6xl font-extrabold text-blue-900 mb-4">404</p>
            <h1 className="text-2xl font-bold text-gray-800 mb-3">Page not found</h1>
            <p className="text-gray-600 mb-8">The page you are looking for doesn’t exist or has been moved.</p>
            <Link to="/" className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700">Go to homepage</Link>
        </div>
    );
}
